import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Modal } from '@shared/ui/Overlays/Modal'
import s from './Modals.module.sass'
import Img from '@images/restorator/promo.webp'
import Image from 'next/image'
import { Text } from '@shared/ui/Typography/Text'

interface Props {
  active: boolean
  onClose: () => void
}

export const PromoModal = ({ active, onClose }: Props) => {
  return (
    <>
      {active && (
        <BlockBoundary>
          <Modal
            title='Промо'
            handleClose={onClose}
            size='S'
            titleSizes='h1 h3'
            className={s.bottomless}
            mobileShadowless={true}>
            <div className={s.content}>
              <Text sizes='ML M' className={s['text-content']}>
                <span>Показы в&nbsp;динамике с выделением цветом и&nbsp;пометкой «Промо»:</span>

                <ul>
                  <li>На&nbsp;1-м и&nbsp;7-м местах в&nbsp;подборках «Выбор Афиши»</li>

                  <li>На&nbsp;1-м месте в списках ресторанов</li>

                  <li>В блоках «Места рядом» и&nbsp;«Похожие заведения»</li>
                </ul>
              </Text>

              <Image src={Img.src} alt='Промо' width={255} height={406} quality={100} />
            </div>
          </Modal>
        </BlockBoundary>
      )}
    </>
  )
}
